export default __webpack_public_path__ + "fonts/a56da0e3a2c2569677b343051cd4722e.svg";